/* Verelle — small progressive-enhancement helpers.
   Everything here is optional: sections render and work without JS. */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Horizontal rail prev/next buttons.
     Scrolls by one "page" of visible cards. Buttons disable at the ends.
     ---------------------------------------------------------------------- */
  function initRail(scope) {
    var wrappers = (scope || document).querySelectorAll('[data-rail]');

    wrappers.forEach(function (rail) {
      if (rail.dataset.railReady === 'true') return;
      rail.dataset.railReady = 'true';

      // The nav lives in the section header, so search the whole section.
      var section = rail.closest('.shopify-section') || document;
      var prev = section.querySelector('[data-rail-prev]');
      var next = section.querySelector('[data-rail-next]');

      if (!prev || !next) return;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
        var cardWidth = first.getBoundingClientRect().width + gap;
        // Scroll by whole cards, at least one.
        var perPage = Math.max(1, Math.floor(rail.clientWidth / cardWidth));
        return cardWidth * perPage;
      }

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        var scrollable = rail.scrollWidth > rail.clientWidth + 2;
        var nav = section.querySelector('[data-rail-nav]');
        if (nav) nav.style.visibility = scrollable ? 'visible' : 'hidden';
      }

      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });

      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init() {
    initRail(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-initialise when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initRail(event.target);
  });
})();
